<template>
  <div class="row">
    <div class="col-md-12">
      <div id="filter-card" class="row py-3 px-4">
        <div class="col-lg-12 col-xl-12 px-0">
          <form @submit.prevent="filterResult()">
            <div class="row align-items-end py-0 my-0 mx-0" v-if="filters">
              <div class="col-lg-4 col-md-4 my-lg-2 my-sm-0 row mx-0 px-0">
                <div class="col-lg-6 col-md-6 col-sm-12 my-2 my-md-0">
                  <date-filter
                    :helper-text="$t('general.start_date')"
                    :model.sync="filters.start_date"
                    name="start_time"
                    title="general.start_date"
                  >
                  </date-filter>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 my-2 my-md-0">
                  <date-filter
                    :helper-text="$t('general.end_date')"
                    :model.sync="filters.end_date"
                    name="end_date"
                    title="general.end_date"
                  >
                  </date-filter>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 m-0 p-0">
                <custom-multi-select
                  :has-bottom-margin="false"
                  :is-inline="false"
                  :model.sync="filters.instruction_type_id"
                  :options="instructionTypeOptions"
                  :title="$t('waybill.waybill_kind')"
                  :max="1"
                  input-width="150px"
                  :required="false"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  name="wayBillKind"
                  :not-list="true"
                />
              </div>
              <div
                class="col-xl-2 col-lg-2 col-md-2 col-sm-12 m-0 p-0"
                style="margin-bottom: 8px !important"
              >
                <custom-multi-select
                  :has-bottom-margin="false"
                  :is-inline="true"
                  :model.sync="filters.waybill_type_id"
                  :options="waybillTypeOptions"
                  :title="$t('waybill.waybill_type')"
                  :max="1"
                  :required="false"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  input-width="150px"
                  name="wayBillWaybillType"
                  :not-list="true"
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 m-0 p-0">
                <custom-multi-select
                  :disabled="id"
                  :max="1"
                  :model.sync="filters.supplier_company_id"
                  :not-list="true"
                  :options="supplierCompanyOptions"
                  :title="$t('waybill.current_account')"
                  :required="false"
                  :is-inline="false"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  input-width="150px"
                  name="waybill_current_company"
                />
              </div>
              <div
                class="col-xl-1 col-lg-1 col-md-1 col-sm-12 mt-3 d-flex align-items-center justify-content-end row"
                style="margin: 0 !important"
              >
                <div class="col-12 pr-0">
                  <button
                    class="w-100 btn btn-sm btn-outline-primary rounded-full font-weight-bold py-1"
                    @click.prevent="filterResult()"
                  >
                    {{ $t("general.filter") }}
                  </button>
                </div>
                <div class="col-12 pr-0">
                  <button
                    class="w-100 btn btn-sm btn-outline-primary rounded-full font-weight-bold mt-2 py-1"
                    @click="resetFilters"
                  >
                    {{ $t("general.clear") }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-5"></div>
        <div class="col-7">
          <dashboard-box :title="$t('report.endorsemet_report')">
            <template v-slot:preview>
              <PurchasingWaybillReportChart
                :start-date.sync="filters.start_date"
                :end-date.sync="filters.end_date"
                :currency-rate-options="currencyRateOptions"
                :instruction-type-id="filters.instruction_type_id"
                :waybill-type-id="filters.waybill_type_id"
                :supplier-company-id="filters.supplier_company_id"
                :onClickButton="onClickButton"
              ></PurchasingWaybillReportChart>
            </template>
          </dashboard-box>
        </div>
      </div>

      <dashboard-box :title="$t('esc.esc_list')">
        <template v-slot:preview>
          <div @contextmenu.prevent="onContextMenu">
            <data-table
              :bordered="false"
              :borderless="true"
              :fields.sync="fields"
              :hover="false"
              :items="formattedReport"
              :no-border-collapse="true"
              :outlined="false"
              :page.sync="page"
              :perPage.sync="perPage"
              :striped="true"
              :infiniteId="infiniteId"
              tableVariant="''"
              @hitBottom="onHitBottom"
              :sortBy.sync="order"
              :sortDesc.sync="sort"
            ></data-table>
          </div>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";

// COMPONENTS
import DashboardBox from "@/assets/components/DashboardBox";
import DataTable from "@/assets/components/dataTable/DataTable";
import TopWaybillNav from "@/view/pages/waybill/layouts/index/TopWaybillNav";
import SecondWaybillNav from "@/view/pages/waybill/layouts/index/SecondWaybillNav";
import InputFilter from "@/assets/components/filters/InputFilter";
import SelectFilter from "@/assets/components/filters/SelectFilter";
import DateFilter from "@/assets/components/filters/DateFilter";
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import PurchasingWaybillReportChart from "./PurchasingReportChart/PurchasingWaybillReportChart";

import {
  HANDLE_INFINITE_SCROLL,
  LOADING,
  SET_ITEMS,
  SET_LOADING,
  ITEMS,
  SET_FILTER,
  FILTER,
} from "@/core/services/store/report/purchasingWaybillReport.module";

import { GET_ITEMS, GET_ITEMS as REST_GET_ITEM } from "@/core/services/store/REST.module";
import { LARAVEL_DATE_FORMAT, MOMENT_SYSTEM_DATE_FORMAT } from "@/core/config/constant";
import * as _ from "lodash";
import ContextMenu from "@/assets/components/contextMenu/ContextMenu";
import {
  PURCHASING_REPORT_START_DATE_STORAGE_NAME,
  PURCHASING_REPORT_END_DATE_STORAGE_NAME,
} from "@/core/storage/storage-names";

export default {
  name: "PurchasingReport",
  components: {
    SelectFilter,
    InputFilter,
    DataTable,
    DashboardBox,
    TopWaybillNav,
    SecondWaybillNav,
    DateFilter,
    CustomMultiSelect,
    ContextMenu,
    PurchasingWaybillReportChart,
  },
  computed: {
    ...mapGetters({
      loading: LOADING,
      filter: FILTER,
      items: ITEMS,
    }),
    filters: {
      get: function () {
        return this.filter;
      },
      set: function (value) {
        this.setFilter(value);
      },
    },
    formattedReport() {
      if (!this.items || this.items.data === null || this.items.data === undefined)
        return [];
      let temp = [];
      this.items.data.forEach((item) => {
        let units = [];
        let orderNumber = [];
        let sumAmount = _.sumBy(item.transactions, function (transaction) {
          if (transaction.unit) {
            units.push(transaction.unit.code);
          }
          orderNumber.push(item.order_number);
          return Number(transaction.net_amount);
        });

        temp.push({
          supplier_company: item.supplier_company ? item.supplier_company.name : "",
          amount: sumAmount.toLocaleString("tr-TR") + " " + _.uniq(units).join(" , "),
          order_number: _.uniq(orderNumber).join(" , "),
          waybill_date: item.waybill_date,
        });
      });
      return temp;
    },
  },
  data() {
    return {
      // Filters & pagination
      infiniteId: 1,
      sort: "desc",
      order: "id",
      sampleStatuses: [],
      fieldsToViewEdit: [],
      customerOptions: [],
      supplierCompanyOptions: [],
      search: null,
      onClickButton: false,
      paginate: [],
      page: 1,
      perPage: 25,
      currentStoreType: 99999999,
      startDate: moment().subtract(30, "d"),
      endDate: moment().add(1, "d"),
      download: false,
      reportListUrl: "api/report/purchasing-waybill",
      currencyRateOptions: [],
      waybillTypeOptions: [],
      companies: [],
      instructionTypeOptionsRaw: [],
      instructionTypeOptions: [],
      fields: [
        {
          key: "supplier_company",
          label: this.$t("general.supplier_company"),
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "order_number",
          label: this.$t("report.order_number"),
          sortable: false,
          class:
            "text-center border border-top-0 border-right-0 font-weight-bolder font-size-lg ",
        },
        {
          key: "amount",
          label: this.$t("general.amount"),
          sortable: false,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "waybill_date",
          label: this.$t("waybill.waybill_date"),
          sortable: false,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      setFilter: SET_FILTER,
    }),

    filterResult() {
      localStorage.setItem(
        PURCHASING_REPORT_START_DATE_STORAGE_NAME,
        moment(this.filters.start_date)
      );
      localStorage.setItem(
        PURCHASING_REPORT_END_DATE_STORAGE_NAME,
        moment(this.filters.end_date)
      );
      let self = this;
      this.page = 1;
      this.filters.page = 1;
      this.infiniteId++;
      this.onClickButton = true;

      this.onHitBottom();
    },
    onHitBottom($state = null) {
      if (this.loading) {
        return;
      }
      let self = this;
      let filters = _.cloneDeep(this.filters);
      this.$set(
        filters,
        "start_date",
        moment(this.filters.start_date).format(LARAVEL_DATE_FORMAT)
      );
      this.$set(
        filters,
        "end_date",
        moment(this.filters.end_date).format(LARAVEL_DATE_FORMAT)
      );

      filters.company_id = this.companyId;
      this.$set(filters, "order", this.order);
      this.$set(filters, "sort", this.sort);

      self.$store
        .dispatch(HANDLE_INFINITE_SCROLL, {
          url: self.reportListUrl,
          filters: filters,
          $state: $state,
        })
        .then((result) => {
          this.infiniteId++;
          this.onClickButton = false;
          if (result.status) {
            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        });
    },
    resetFilters() {
      (this.sort = "desc"),
        (this.order = "id"),
        this.setFilter({
          page: 1,
          per_page: 25,
          search: "",
          start_date: moment().subtract(30, "d").format(LARAVEL_DATE_FORMAT),
          end_date: moment().add(1, "d").format(LARAVEL_DATE_FORMAT),
        });
    },
    setup() {
      let self = this,
        promises = [];
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/companies",
        })
      );
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/currency-rate",
        })
      );

      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/instruction-type",
        })
      );

      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/waybill-types",
        })
      );

      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/supplier-companies",
        })
      );

      Promise.all(promises).then((results) => {
        if (results[0].status) {
          self.customerOptions = self.convertArrayToObjectByKey(
            results[0].data,
            "id",
            "name"
          );
        }
        if (results[1].status) {
          self.companies = this.currencyRateOptions = results[1].data.data;
        }
        if (results[2].status) {
          self.instructionTypeOptionsRaw = results[2].data;
          self.instructionTypeOptions = self.convertArrayToObjectByKey(
            results[2].data,
            "id",
            "translations.0.name"
          );
        }
        if (results[3].status) {
          self.waybillTypeOptions = self.convertArrayToObjectByKey(
            results[3].data,
            "id",
            "translations.0.name"
          );
        }
        if (results[4].status) {
          self.supplierCompanyOptions = self.convertArrayToObjectByKey(
            results[4].data,
            "id",
            "name"
          );
        }
      });
    },
  },
  created() {
    this.$store.commit(SET_LOADING, false);
    this.$store.commit(SET_ITEMS, {});
  },
  mounted() {
    let self = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("menu.purchasing_waybill_report") },
    ]);

    if (!this.isUserGranted("EscTable", ["viewAny"])) {
      return false;
    }

    if (!this.filter) {
      this.resetFilters();
    }

    this.filters.end_date = localStorage.hasOwnProperty(
      PURCHASING_REPORT_END_DATE_STORAGE_NAME
    )
      ? moment(localStorage.getItem(PURCHASING_REPORT_END_DATE_STORAGE_NAME))
      : moment().add(1, "d").format(LARAVEL_DATE_FORMAT);

    this.filters.start_date = localStorage.hasOwnProperty(
      PURCHASING_REPORT_START_DATE_STORAGE_NAME
    )
      ? moment(localStorage.getItem(PURCHASING_REPORT_START_DATE_STORAGE_NAME))
      : moment().subtract(30, "d").format(LARAVEL_DATE_FORMAT);

    this.setup();
  },
  watch: {
    sort() {
      this.filterResult();
    },
    order() {
      this.filterResult();
    },
  },
};
</script>

<style>
*:focus {
  outline: none;
}

#dashboard-card-body {
  padding-bottom: 5px !important;
}
</style>
